import { SubscriptionPlan } from '../types';
import { INITIAL_PLANS } from '../data/mockState';

const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
const CURRENT_SUB_KEY = 'idfraud_current_subscription';
const PLANS_CONFIG_KEY = 'idfraud_plans_config';

export function getStoredPlans(): SubscriptionPlan[] {
  const raw = localStorage.getItem(PLANS_CONFIG_KEY);
  if (raw) {
    try {
      return JSON.parse(raw);
    } catch {
      return INITIAL_PLANS;
    }
  }
  localStorage.setItem(PLANS_CONFIG_KEY, JSON.stringify(INITIAL_PLANS));
  return INITIAL_PLANS;
}

export async function getSubscriptionPlans(): Promise<SubscriptionPlan[]> {
  await delay(200);
  return getStoredPlans();
}

export async function getCurrentSubscription(): Promise<{
  planId: 'free' | 'personal' | 'family';
  status: 'active' | 'trial' | 'cancelled';
  renewsAt: string;
  interval: 'monthly' | 'annual';
}> {
  const raw = localStorage.getItem(CURRENT_SUB_KEY);
  if (raw) {
    try {
      return JSON.parse(raw);
    } catch {
      // ignore
    }
  }
  return {
    planId: 'personal',
    status: 'active',
    renewsAt: '2026-09-20T00:00:00Z',
    interval: 'monthly'
  };
}

export async function updateSubscription(
  planId: 'free' | 'personal' | 'family', 
  interval: 'monthly' | 'annual' = 'monthly'
): Promise<{ success: boolean; planId: string }> {
  await delay(600);
  const sub = {
    planId,
    status: 'active',
    renewsAt: new Date(Date.now() + (interval === 'annual' ? 365 : 30) * 86400000).toISOString(),
    interval
  };
  localStorage.setItem(CURRENT_SUB_KEY, JSON.stringify(sub));
  return { success: true, planId };
}

export async function updatePlanConfig(updatedPlans: SubscriptionPlan[]): Promise<SubscriptionPlan[]> {
  await delay(400);
  localStorage.setItem(PLANS_CONFIG_KEY, JSON.stringify(updatedPlans));
  return updatedPlans;
}
